import React from "react";
import Navbar from "../components/Navbar";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

const DashboardLayout = () => {
  return (
    <PageWrapper>
      <Navbar />
      <Main>
        <Outlet />
      </Main>
    </PageWrapper>
  );
};

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Main = styled.main`
  flex: 1 0 auto;
  background-color: #eee;
  padding: 1rem;
`;
export default DashboardLayout;
